import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth, landingFor } from "../lib/auth";
import { DEMO_MODULES, getDemo, startDemo, switchDemoRole } from "../lib/demo";
import { Loading } from "../components/common";
import { Notice, Btn } from "../components/kit";

export default function DemoStart() {
  const { t, i18n } = useTranslation();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const ran = useRef(false);
  const run = async () => {
    setFailed(false);
    try {
      const d = getDemo();
      if (d) {
        switchDemoRole(d.role || "groomer");
        const me = await refresh();
        if (me?.user?.sandbox_id) return navigate(landingFor(me), { replace: true });
      }
      await startDemo(i18n.language?.startsWith("ru") ? "ru" : "en");
      await refresh();
      navigate("/home", { replace: true });
    } catch { setFailed(true); }
  };
  useEffect(() => { if (!ran.current) { ran.current = true; run(); } }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (failed) return <div className="mx-auto max-w-md p-6 space-y-3"><Notice tone="warn" testid="demo-start-error">{t("sandbox.start_failed")}</Notice><Btn testid="demo-retry-btn" onClick={run}>{t("upload.retry")}</Btn></div>;
  return <div data-testid="demo-starting"><Loading /></div>;
}

export function DemoModules() {
  const { t } = useTranslation();
  return (
    <div className="space-y-4" data-testid="demo-modules-page">
      <h1 className="font-display text-3xl font-extrabold">{t("sandbox.modules_title")}</h1>
      <p className="text-muted-foreground">{t("sandbox.modules_sub")}</p>
      <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {DEMO_MODULES.map((m) => (
          <li key={m} data-testid={`demo-module-${m}`} className="rounded-2xl border border-dashed bg-white/70 p-4">
            <span data-testid={`coming-later-${m}`} className="rounded-full bg-muted px-2 py-0.5 text-xs font-semibold">{t("sandbox.coming_later")}</span>
            <p className="mt-2 font-semibold">{t(`sandbox.modules.${m}`)}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
